import { useEffect, useState } from 'react';

const useProgress = (maxTimeInSeconds: number) => {
  const [elapsedTime, setElapsedTime] = useState(0);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (progress < 1) {
        setElapsedTime((t) => t + 1);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    setProgress((elapsedTime / (maxTimeInSeconds * 10)) * 1000);
  }, [elapsedTime]);

  return progress;
};

export default useProgress;
